<template>
    <div class="small-12 large-3 wrapper-filter">
        <h3>Filtrer les biens </h3>
        <div class="wrapper-input hide-smart">
            <label for="descFilter">Détail</label>
            <input type="text" id="descFilter" :value="descFilterValue" v-on:input="filterDesc">
        </div>     
        <div class="wrapper-input">
            <label for="cityFilter">Ville</label>
            <select name="cityFilter" id="cityFilter" multiple="true" ref="cityFilter" @change="filterCityOption">
                <option v-for="option in citiesOptions" :value="option.value" :key="option.value">
                    {{ option.text }}
                </option>
            </select>
        </div>
        <div class="wrapper-input">
            <label for="typeFilter">Type de bien</label>
            <div class="wrapper-checkbox" v-for="option in typeOptions" :key="option.value">
                <input type="checkbox" :name="option.text" :id="option.text" :ref="option.text" :value="option.text" @change="filterTypeCheckbox" :checked="option.value"/>
                <label :for="option.text">{{option.text}}</label>
            </div>
        </div>    
        <div class="wrapper-input price">
            <label for="amountFilter">Prix</label>
            <DoubleRange ref="amountFilter" :value="1" :valuemin="minPrice" :valuemax="maxPrice" :step="1" @input="filterPrice"/>
        </div> 
        <div class="wrapper-input">
            <label for="surfaceFilter">Surface en m2</label>
            <DoubleRange ref="surfaceFilter" :value="1" :valuemin="minSurface" :valuemax="maxSurface" :step="1" @input="filterSurface"/>
        </div>        
        <div class="wrapper-input">
            <label for="roomFilter">Pièces</label>
            <DoubleRange ref="roomFilter" :value="1" :valuemin="minRoom" :valuemax="maxRoom" :step="1" @input="doubleFilter"/>
        </div> 
        
        <br>
        <hr>
        <br>
        <div class="wrapper-input align-center">
            <button @click="reinitFilter" class="btn border">Effacer les filtres</button>
        </div> 
    </div>    
</template>

<script>
import DoubleRange from "./DoubleRange";

export default {
    name: "FilterTool",
    components: {
        DoubleRange,
    },
    props: {
        propertiesFound: Number,
        descFilterValue: String,
        valueCity: String,
        minPrice: Number,
        maxPrice: Number,
        minSurface: Number,
        maxSurface: Number,
        minRoom: Number,
        maxRoom: Number,
        citiesOptions: Array,
        typeOptions: Array,
    },
    data() {
        return {
            selectedPrice: this.minPrice,
            cbTypeSelected: [],
            selCitiesSelected: []
        }
    },
    methods: {  
        filterDesc(e) {
            this.$emit("filter-multiple", {type:"desc", "value":e.target.value });
        },
        filterCityOption(e) {
            //get all selected options
            this.selCitiesSelected = [...e.target.options].filter(option => option.selected).map(option => option.value);
            this.$emit("filter-multiple", {type:"cityOption", "value":this.selCitiesSelected });
        },
        rangePrice(e) {             
            this.selectedPrice = e.target.value;
            this.$emit("filter-multiple", {type:"price", "value":e.target.value});
        },
        filterType(e) {            
            this.$emit("filter-multiple", {type:"type", "value":e.target.value});
        },
        filterTypeCheckbox(e) {            
            let indexOfTarget = this.cbTypeSelected.indexOf(e.target.value);
            // console.log("emit filter Type ", e.target.checked, indexOfTarget);
            if(e.target.checked) {
                if(indexOfTarget !== -1) return;
                
                this.cbTypeSelected.push(e.target.value);
            } else {
                if(indexOfTarget !== -1) {
                    this.cbTypeSelected.splice(indexOfTarget,1);
                }
            }
            console.log(this.cbTypeSelected);
            this.$emit("filter-multiple", {type:"type", "value":this.cbTypeSelected});
        },
        doubleFilter(valueArray) {
            // if receive Value is an array, we emit values to parent
            if(valueArray.constructor === Array)
                this.$emit("filter-multiple", {type:"room", "value":valueArray[0], "value02": valueArray[1]});
        },        
        filterSurface(valueArray) {
            // if receive Value is an array, we emit values to parent
            if(valueArray.constructor === Array)
                this.$emit("filter-multiple", {type:"surface", "value":valueArray[0], "value02": valueArray[1]});
        },
        filterPrice(valueArray) {
            // if receive Value is an array, we emit values to parent
            if(valueArray.constructor === Array)
                this.$emit("filter-multiple", {type:"price", "value":valueArray[0], "value02": valueArray[1]});
        },
        reinitFilter(){
            //reinit input 
            this.$refs.amountFilter.value = "0"; //amount filter
            //this.$refs.cityFilter.selectedIndex = 0;
            this.citiesOptions.forEach(option => {             
                this.selCitiesSelected.push(option.text);                
            });
            //checkbox options get all values without external filter
            this.cbTypeSelected = [];            
            this.typeOptions.forEach(option => {
                this.$refs[option.text].checked = true;                
                this.cbTypeSelected.push(option.text);                
            });
            // double input, call to child reinit function
            this.$refs.surfaceFilter.reinit();
            this.$refs.roomFilter.reinit();
            this.$refs.amountFilter.reinit();
                        
            //we send all type options to the parent to display all type of properties
            this.$emit("reinit-filter", this.cbTypeSelected, this.citiesOptions);
        }
    },
    mounted() {
        //if we have an external filter Type in the url, we make a filtering of the list
        this.typeOptions.forEach(option => {
            if(option.value) {
                this.cbTypeSelected.push(option.text);                
            }
        });
        this.$emit("filter-multiple", {type:"type", "value":this.cbTypeSelected});

        this.citiesOptions.forEach(option => {
            if(option.value) {
                this.selCitiesSelected.push(option.text);                
            }
        });
        this.$emit("filter-multiple", {type:"cityOption", "value":this.selCitiesSelected});
        // if(this.cbTypeSelected.length > 0) {
        //     this.$emit("filter-multiple", {type:"type", "value":this.cbTypeSelected});
        // } 
    }
}
</script>

<style>
.wrapper-input {
    padding: 10px;
}
</style>